import { createSlice } from "@reduxjs/toolkit";


const initialState = {
  id: null,
  createdAt: null,
  updatedAt: null,
  publishedAt: null,
  
  quotationText: null,
  clientLogo: null,
  jasperLogo: null,
  aboutUs: [],
  featuredSection: [],
  headerTabs: [],
  
  header: {},
  activeInternalPage: 0,
  colorCode: '',
  backgroundImageDesktop: null,
  backgroundImageMobile:null,
  theme: "CipNew"
}

export const sliceName = "pitchDeckV2Slice"
export const pitchDeckSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    setPitchDeckData: (state, action) => {
      const pitchDeckData = action.payload;
      
      // Handle data structure from dummy.json
      if (pitchDeckData.aboutUs) {
        state.aboutUs = pitchDeckData.aboutUs;
      }
      if (pitchDeckData.featuredSection) {
        state.featuredSection = pitchDeckData.featuredSection;
      }
      if (pitchDeckData.headerTabs) {
        state.headerTabs = pitchDeckData.headerTabs;
        // Create header object from headerTabs
        const header = {};
        pitchDeckData.headerTabs.forEach((tab, index) => {
          header[index] = tab.tabName || `Tab ${index + 1}`;
        });
        state.header = header;
      }
      if (pitchDeckData.clientLogo) {
        state.clientLogo = pitchDeckData.clientLogo;
      }
      if (pitchDeckData.jasperLogo) {
        state.jasperLogo = pitchDeckData.jasperLogo;
      }
      if (pitchDeckData.quotationText) {
        state.quotationText = pitchDeckData.quotationText;
      }
      
      // Handle basic info
      if (pitchDeckData.id) state.id = pitchDeckData.id;
      if (pitchDeckData.createdAt) state.createdAt = pitchDeckData.createdAt;
      if (pitchDeckData.updatedAt) state.updatedAt = pitchDeckData.updatedAt;
      if (pitchDeckData.publishedAt) state.publishedAt = pitchDeckData.publishedAt;
      
      // Handle theme
      if (pitchDeckData.theme) {
        state.theme = pitchDeckData.theme;
      }

      // Handle colorCode
      if (typeof pitchDeckData.colorCode === 'string') {
        state.colorCode = pitchDeckData.colorCode;
      }

      // Handle backgroundImageDesktop
      if (pitchDeckData.backgroundImageDesktop) {
        state.backgroundImageDesktop = pitchDeckData.backgroundImageDesktop;
      }

      if (pitchDeckData.backgroundImageMobile) {
        state.backgroundImageMobile = pitchDeckData.backgroundImageMobile;
      }
    },
    setActiveInternalPage: (state, action) => {
      state.activeInternalPage = action.payload
    }
  }
})


// Main selectors
export const pitchDeckDataState = state => state[sliceName]
export const pitchDeckHeaders = state => state[sliceName].header
export const pitchDeckActiveInternalPage = state => state[sliceName].activeInternalPage

// Content selectors from dummy.json
export const selectAboutUs = state => state[sliceName].aboutUs
export const selectFeaturedSection = state => state[sliceName].featuredSection
export const selectHeaderTabs = state => state[sliceName].headerTabs
export const selectClientLogo = state => state[sliceName].clientLogo
export const selectJasperLogo = state => state[sliceName].jasperLogo
export const selectQuotationText = state => state[sliceName].quotationText


// UI selectors
export const activeTheme = state => state[sliceName].theme
export const colorCode = state => state[sliceName].colorCode
export const backgroundImageDesktop = state => state[sliceName].backgroundImageDesktop
export const backgroundImageMobile = state => state[sliceName].backgroundImageMobile


export const { setPitchDeckData, setActiveInternalPage } = pitchDeckSlice.actions
export default pitchDeckSlice.reducer